import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-history',
  templateUrl: './delete-history.component.html',
  styleUrls: ['./delete-history.component.scss']
})
export class DeleteHistoryComponent {

}
